import { getTimeString } from '../../../../backend/utils/getTimeString';
import { useMissionsTranslation } from '../../../../ui/hooks';
import { IconPlaceholder } from '@juvare/common-web-ui/IconPlaceholder';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import AssignmentIndOutlinedIcon from '@mui/icons-material/AssignmentIndOutlined';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import TimelapseIcon from '@mui/icons-material/Timelapse';
import { Box, Stack, Typography } from '@mui/material';
import React from 'react';
const NameAndPositionColumn = ({ row }) => {
    return (React.createElement(Stack, { spacing: 1 },
        React.createElement(Typography, { variant: 'h6' }, row.participantFullName),
        React.createElement(Typography, { variant: 'subtitle2', sx: { color: themeColors.text.subtle } }, row.positionName)));
};
const ShiftsColumn = ({ row }) => {
    const { t } = useMissionsTranslation();
    return (React.createElement(Box, { sx: { display: 'flex', alignItems: 'center', gap: '8px' } },
        React.createElement(IconPlaceholder, { status: row.shifts ? 'primary' : 'disabled' },
            React.createElement(AssignmentIndOutlinedIcon, null)),
        React.createElement(Typography, { variant: 'body2' }, t('timeTracking.shifts', { count: row.shifts }))));
};
const ApprovedColumn = ({ row }) => {
    const { t } = useMissionsTranslation();
    return (React.createElement(Box, { sx: { display: 'flex', alignItems: 'center', gap: '8px' } },
        React.createElement(IconPlaceholder, { status: row.approvedHours ? 'success' : 'disabled' },
            React.createElement(CheckCircleOutlineIcon, null)),
        React.createElement(Typography, { variant: 'body2' },
            React.createElement(Typography, { variant: 'subtitle2', component: 'span' }, getTimeString(row.approvedHours, true)),
            t('timeTracking.approved'))));
};
const PendingColumn = ({ row }) => {
    const { t } = useMissionsTranslation();
    return (React.createElement(Box, { sx: { display: 'flex', alignItems: 'center', gap: '8px' } },
        React.createElement(IconPlaceholder, { status: row.pendingHours ? 'warning' : 'disabled' },
            React.createElement(TimelapseIcon, null)),
        React.createElement(Typography, { variant: 'body2' },
            React.createElement(Typography, { variant: 'subtitle2', component: 'span' },
                getTimeString(row.pendingHours, true),
                ' '),
            t('timeTracking.pending'))));
};
export function useParticipantsWithPastShiftsColumns(t) {
    return React.useMemo(() => [
        {
            headerLabel: t('shifts.shiftsByVolunteerTable.nameAndPosition'),
            cellFunction: (row) => React.createElement(NameAndPositionColumn, { row: row }),
        },
        {
            headerLabel: t('shifts.shiftsByVolunteerTable.shifts'),
            cellFunction: (row) => React.createElement(ShiftsColumn, { row: row }),
            sortKey: 'participantFullName',
        },
        {
            headerLabel: t('shifts.shiftsByVolunteerTable.approvedHours'),
            cellFunction: (row) => React.createElement(ApprovedColumn, { row: row }),
            sortKey: 'participantFullName',
        },
        {
            headerLabel: t('shifts.shiftsByVolunteerTable.pendingHours'),
            cellFunction: (row) => React.createElement(PendingColumn, { row: row }),
            sortKey: 'participantFullName',
        },
    ], [t]);
}
